/**
 * Client for the in-app notifications API (workers/vte-api-worker/src/routes/notifications.ts).
 */
import api from '@/lib/api'

export interface AppNotification {
  uuid: string
  type: 'video-ready' | 'video-failed' | 'full-tour-ready' | 'full-tour-partial' | 'full-tour-failed' | 'import-completed' | string
  title: string | null
  body: string | null
  link: string | null
  tour_uuid: string | null
  meta: Record<string, unknown> | null
  read: boolean
  read_at: string | null
  created_at: string
}

export interface NotificationsResponse {
  notifications: AppNotification[]
  total: number
  unread_count: number
  page: number
  limit: number
}

export const notificationsApi = {
  list: (params: { page?: number; limit?: number; unread?: boolean } = {}) => {
    const search = new URLSearchParams()
    if (params.page) search.set('page', String(params.page))
    if (params.limit) search.set('limit', String(params.limit))
    if (params.unread) search.set('unread', '1')
    const qs = search.toString()
    return api.get<NotificationsResponse>(`/api/notifications${qs ? `?${qs}` : ''}`)
  },
  markRead: (uuids: string[]) => api.post<{ updated: number }>('/api/notifications/read', { uuids }),
  markAllRead: () => api.post<{ updated: number }>('/api/notifications/read', { all: true }),
}

export default notificationsApi
